import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const SearchIcon = ({ label = 'Search', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M264.2 274.2a10.2 10.2 0 0 1-7.1-2.9l-78.5-78.6a10 10 0 1 1 14.1-14.1l78.6 78.5a10.1 10.1 0 0 1 0 14.2 10.2 10.2 0 0 1-7.1 2.9z" style="fill:#1d1d1b"/><circle data-currentcolor="true" cx="121.1" cy="121" r="85.2" style="fill:currentColor"/><path d="M121.1 35.8A85.3 85.3 0 1 1 35.8 121a85.1 85.1 0 0 1 85.3-85.2m0-10a95.2 95.2 0 0 0-67.4 162.6A95.2 95.2 0 1 0 188.4 53.7a94.6 94.6 0 0 0-67.3-27.9z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

SearchIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { SearchIcon }
